import { useLocales } from '@/Locales';
import { Form, Modal, ModalProps } from '@sinohealth/butterfly-ui-components/lib';
import { useEffect, useRef, useState } from 'react';

interface BaseFormModalProps extends ModalProps {
  formModal: any;
  onNeedDel?: () => void;
  onSubmit: (formData?: any) => Promise<any>;
  FormContent: any;
  confirmCancel?: boolean;
}

const BaseFormModal = (props: BaseFormModalProps) => {
  const {
    formModal,
    onSubmit,
    FormContent,
    onNeedDel,
    confirmCancel = false,
    ...otherProps
  } = props;
  const [defaultFormData, setDefaultFormData] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const { t } = useLocales();

  useEffect(() => {
    if (!formModal) {
      return;
    }
    formModal.current = {
      form,
      openModal,
      closeModal,
    };
  }, []);
  const openModal = (defaultData: any = {}) => {
    setDefaultFormData(defaultData);
    setVisible(true);
  };

  const closeModal = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    if (confirmCancel) {
      Modal.confirm({
        title: `${t('确认关闭弹窗')}？`,
        content: t('表单尚未提交，关闭弹窗会丢失未提交的内容'),
        onOk: () => {
          closeModal();
          onNeedDel?.();
        },
      });
    } else {
      closeModal();
      onNeedDel?.();
    }
  };

  const handleOk = (data?: any) => {
    form.submit();
  };

  const handleSubmit = (formValues: any) => {
    const formData = {
      ...defaultFormData,
      ...formValues,
    };
    setSubmitLoading(true);
    onSubmit(formData)
      .then(() => {
        closeModal();
        setSubmitLoading(false);
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  useEffect(() => {
    if (visible) {
      form.resetFields();
      form.setFieldsValue(defaultFormData);
    }
  }, [visible, defaultFormData]);

  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      onOk={handleOk}
      cancelButtonProps={{
        disabled: submitLoading,
      }}
      okButtonProps={{
        loading: submitLoading,
      }}
      destroyOnClose={false}
      {...otherProps}
    >
      <FormContent
        defaultFormData={defaultFormData}
        form={form}
        colon={false}
        onFinish={handleSubmit}
        onCancel={closeModal}
        labelAlign="right"
        labelCol={{ span: 4 }}
      />
    </Modal>
  );
};

export const useFormModal = () => {
  const formModal: any = useRef();
  return formModal;
};

export default BaseFormModal;
